module.exports = __webpack_public_path__ + "img/doorLogo22.0fa54855.png";